export default {
  GET_AUTO_SYNC_CONFIG_REQUEST: 'GET_AUTO_SYNC_CONFIG_REQUEST',
  GET_AUTO_SYNC_CONFIG_SUCCESS: 'GET_AUTO_SYNC_CONFIG_SUCCESS',
  GET_AUTO_SYNC_CONFIG_FAIL: 'GET_AUTO_SYNC_CONFIG_FAIL',

  TOGGLE_AUTO_SYNC_REQUEST: 'TOGGLE_AUTO_SYNC_REQUEST',
  TOGGLE_AUTO_SYNC_SUCCESS: 'TOGGLE_AUTO_SYNC_SUCCESS',
  TOGGLE_AUTO_SYNC_FAIL: 'TOGGLE_AUTO_SYNC_FAIL',

  CREATE_AUTO_SYNC_RULE_REQUEST: 'CREATE_AUTO_SYNC_RULE_REQUEST',
  CREATE_AUTO_SYNC_RULE_SUCCESS: 'CREATE_AUTO_SYNC_RULE_SUCCESS',
  CREATE_AUTO_SYNC_RULE_FAIL: 'CREATE_AUTO_SYNC_RULE_FAIL',

  UPDATE_AUTO_SYNC_RULE_REQUEST: 'UPDATE_AUTO_SYNC_RULE_REQUEST',
  UPDATE_AUTO_SYNC_RULE_SUCCESS: 'UPDATE_AUTO_SYNC_RULE_SUCCESS',
  UPDATE_AUTO_SYNC_RULE_FAIL: 'UPDATE_AUTO_SYNC_RULE_FAIL',

  DELETE_AUTO_SYNC_RULE_REQUEST: 'DELETE_AUTO_SYNC_RULE_REQUEST',
  DELETE_AUTO_SYNC_RULE_SUCCESS: 'DELETE_AUTO_SYNC_RULE_SUCCESS',
  DELETE_AUTO_SYNC_RULE_FAIL: 'DELETE_AUTO_SYNC_RULE_FAIL',
}
